import Check from '../icons/Check'
import styles from './Checkbox.module.css'

interface Checkbox {
  label: string,
  id: string,
  checked: boolean,
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

function Checkbox({
  label,
  id,
  onChange,
  checked,
}: Checkbox) {
  return (
    <div>
      <input className={styles.checkboxInput} onChange={onChange} id={id} type="checkbox" checked={checked} />
      <label className={styles.checkboxLabel} htmlFor={id}>
        <span className={styles.checkbox}>
          <Check className={styles.checkIcon} color="currentColor" />
        </span>
        <span>{label}</span>
      </label>
    </div>
  )
}

export default Checkbox
